var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.14264,157.55817a68,68,0,1,0-72.28528,0A119.88963,119.88963,0,0,0,16.083,194.85156a8.00012,8.00012,0,0,0,12.25,10.293,104.007,104.007,0,0,1,159.33447,0,8.00012,8.00012,0,0,0,12.25-10.293A119.89043,119.89043,0,0,0,144.14264,157.55817ZM56,100a52,52,0,1,1,52,52A52.059,52.059,0,0,1,56,100Zm192.24854,43.07178-4.6568-2.68866a23.73294,23.73294,0,0,0,0-8.76624l4.6568-2.68866a8,8,0,1,0-8-13.85644l-4.66816,2.69519A23.99995,23.99995,0,0,0,228,113.3761V108a8,8,0,0,0-16,0v5.3761a23.99995,23.99995,0,0,0-7.58038,4.39087l-4.66816-2.69519a8,8,0,1,0-8,13.85644l4.6568,2.68866a23.73294,23.73294,0,0,0,0,8.76624l-4.6568,2.68866a8,8,0,1,0,8,13.85644l4.66816-2.69519A23.99995,23.99995,0,0,0,212,158.6239V164a8,8,0,0,0,16,0v-5.3761a23.99995,23.99995,0,0,0,7.58038-4.39087l4.66816,2.69519a8,8,0,0,0,8-13.85644ZM212,136a8,8,0,1,1,8,8A8.00917,8.00917,0,0,1,212,136Z",
    stroke: "black",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGear);
export default __webpack_public_path__ + "static/media/users-gear.1c609a213dfca832d7c7f056c55416d1.svg";
export { ForwardRef as ReactComponent };